import types from "../actionTypes";
export default function setLoaderAction(isLoading) {
  return {
    type: types.SET_LOADER,
    isLoading,
  };
}
